/**
 * @author shaojingchao
 * @date 2018/12/7
 * @project kaoshizhongxin
 */
import Vue from 'vue'
import MessageBoxComponent from './message-box.vue'
import { defaultCfg, typeCfg } from './default-cfg'
import { getScrollbarWidth } from '../../utils/scrollbar-width'

let zIndex = defaultCfg.zIndex

const MessageBoxCtor = Vue.extend(MessageBoxComponent)
let instancePool = []

let getAnInstance = () => {
  return new MessageBoxCtor({
    data: {
      isFnCall: true
    }
  }).$mount()
}

let closedInstanceAddToPool = instance => (instance && instancePool.push(instance))

MessageBoxCtor.prototype.$_remove = function () {
  closedInstanceAddToPool(this)
  return this
}

let MessageBox = (options = {}) => {
  let instance = getAnInstance()
  instance.zIndex = zIndex++
  _.forOwn(Object.assign({}, defaultCfg, options, typeCfg[options.type || 'confirm']), (val, key) => {
    instance.$set(instance.opts, key, val)
  })
  Vue.nextTick(() => {
    instance.open()
    // $('body').css({overflowY: 'hidden', paddingRight: getScrollbarWidth()})
    // instance.visible = true
  })
  document.body.appendChild(instance.$el)
  return instance
}

export default MessageBox
